import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 lg:px-8 py-8 text-gray-900 text-base leading-6 border-t border-violet-500/20" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-159">
      <div className="mx-auto max-w-3xl text-center" data-id="element-160">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-violet-700" data-id="element-161">
          🧠 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-162">
          El sistema clínico N°1 para psicólogos en Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-5" data-id="element-163">
          Porque ejercer la psicología con criterio no debería costarte todas
          las noches de la semana.
        </p>

        {/* Contact Info */}
        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-600" data-id="element-164">
          <span data-id="element-165">📧 construyeprogresoo@gmail.com</span>
          <span className="hidden sm:block text-gray-300" data-id="element-166">•</span>
          <span data-id="element-167">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-300" data-id="element-168">•</span>
          <span data-id="element-169">🌐 www.construyeprogreso.com</span>
        </div>

        {/* Divider */}
        <div className="mb-5 h-px bg-violet-500/20" data-id="element-170" />

        {/* Copyright */}
        <p className="text-[10px] text-gray-500 m-0 mb-1" data-id="element-171">
          © Construye Progreso™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-gray-400 m-0 mb-4" data-id="element-172">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}